<template>
    <td>
      <div v-if="formEdit">
      <input type="text" class="form-control" :placeholder="placeholder" v-model="value" v-on:input="updateInput"/>
      </div>
      <div v-if="!formEdit">
        <span class="input-text">{{value}}</span>
        <!--i v-if="editMode" v-on:click="modeChange" class="form-label-icon icon-lineIcon-edit" ></i-->
      </div>
    </td>
</template>

<script>
export default {

  props: {
    value: {
      type: String,
      default: function() {
        return "";
      }
    },
    placeholder: {
      type: String,
      default: function() {
        return "";
      }
    },
    editMode: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    user: Object,
    /*
    formEdit: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
    */
  },
  data() { 
    return {
      inputText: '',
      formField: null,
      testData:'',
      tempData: null,
      formEdit: false,
      //user: {name: 'jiyeon'}
  }},
  mounted() {
    this.tempData = this.value;
  },
  methods: {
    updateInput: function(event) {
      var updatedText = event.target.value;
      this.value = updatedText;
      this.$emit('input', event.target.value);
    },
    confirmInput(event) {
      
      //this.$parent.$emit("confirmInput");
      this.$emit("confirmInput");
      this.formEdit = false;
    },
    cancelInput(event) {
      //this.$parent.$emit("cancelInput");
      this.$emit('input', this.tempData);
      this.formEdit = false;
    },
    /*
    modeChange(){
      this.formEdit = !this.formEdit;
    },
    */
  }
}
</script>

<style>

</style>